import { Pagination } from "services/search";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

import { transformRegistrationExpiryRow } from "./transformations";
import {
  RegistrationExpiryRow,
  RegistrationExpirySearchFormValues,
  RegistrationExpirySummary,
} from "./types";

/*---------------------------------------------------------------------------------------
  SEARCH — istek registracije (kroz sva vozila)
-----------------------------------------------------------------------------------------*/
export const getRegistrationExpiriesAPI = async (
  pagination: Pagination,
  values: RegistrationExpirySearchFormValues
): Promise<DataWithPagination<RegistrationExpiryRow>> => {
  let path = `/v1/fleet/registration-expiries?`;

  if (values.search) path += `&search=${values.search}`;
  if (values.expirationDateFrom)
    path += `&expirationDateFrom=${values.expirationDateFrom.toISOString()}`;
  if (values.expirationDateTo)
    path += `&expirationDateTo=${values.expirationDateTo.toISOString()}`;
  if (values.status) path += `&status=${values.status}`;

  return await paginatedApiCall(
    path,
    pagination,
    transformRegistrationExpiryRow
  );
};

/*---------------------------------------------------------------------------------------
  SUMMARY — brojači po statusu
-----------------------------------------------------------------------------------------*/
export const getRegistrationExpirySummaryAPI =
  async (): Promise<RegistrationExpirySummary> => {
    const response = await createApiCall(
      {
        path: `/v1/fleet/registration-expiries/summary`,
        method: "GET",
      },
      {
        getMessage: {
          error: (error: any) => `${transformErrorResponse(error)}`,
        },
      }
    )();

    return {
      expired: response.data?.expired ?? 0,
      expiring: response.data?.expiring ?? 0,
      valid: response.data?.valid ?? 0,
      total: response.data?.total ?? 0,
    };
  };
